<script>
    import 'leaflet/dist/leaflet.css'
    import { onMount, onDestroy } from 'svelte'
    import SearchField from './SearchField.svelte'
    import leaflet from 'leaflet'
    import picker from '../../../assets/picker.svg'
    import shadow from '../../../assets/shadow-picker-f.png'
    export let lat = 0
    export let lng = 0
    export let zoom = 4
    export let search = ''
    export let automark = true
    export let placeholder = 'Buscar ubicación'
    export let locationMetadata = null
    export let loading = false
    export let disabled = false
    export let searchBar = true
    export let coordinates = [lat, lng]

    let map
    let tiles
    let currentMark
    let cursor = setTimeout(() => {}, 5)
    let ele
    let lastLocation = `${lat},${lng}`
    // const cf = 1 - Number(getComputedStyle(document.body).getPropertyValue('zoom'))

    var myIcon = leaflet.icon({
        iconUrl: picker,
        iconSize: [44, 44],
        iconAnchor: [22, 44],
        shadowUrl: shadow,
        shadowSize: [66.46, 44],
        shadowAnchor: [22.16, 44],
    })

    function setMark(lat, lng) {
        currentMark?.remove()
        currentMark = leaflet.marker([lat, lng], { icon: myIcon })
        currentMark.addTo(map)
        let inDisplayMark = map.getBounds().contains(currentMark.getLatLng())
        if (!inDisplayMark) {
            map.setView([lat, lng], zoom)
        }
        coordinates = [lat, lng]
    }

    onMount(() => {
        var latitude,
            longitude = {}
        map = leaflet.map('map')
        if (lat && lng) {
            map.setView([lat, lng], zoom)
        }
        map.on('click', function (e) {
            if (!disabled) {
                lastLocation = `${lat},${lng}`
                let { lat: L, lng: l } = e.latlng
                // if(currentMark){
                // 	currentMark.remove()
                // }
                setMark(L, l)
            }
        })

        map.on('zoomend', function (e) {
            zoom = e.target._zoom
        })

        // const Stadia_AlidadeSatellite = leaflet.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.{ext}', {
        // 	minZoom: 0,
        // 	maxZoom: 20,
        // 	// attribution: '&copy; CNES, Distribution Airbus DS, © Airbus DS, © PlanetObserver (Contains Copernicus Data) | &copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        // 	ext: 'jpg'
        // })//.addTo(map);

        // const Esri_WorldImagery = leaflet.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        // 	attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        // })//.addTo(map);

        // var CartoDB_VoyagerLabelsUnder = leaflet.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
        // 	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        // 	subdomains: 'abcd',
        // 	maxZoom: 20
        // })//.addTo(map)

        tiles = leaflet
            .tileLayer('http://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution:
                    '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            })
            .addTo(map)

        let hasLocation = lat && lng

        if (!hasLocation && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    // Success
                    let latitude = position.coords.latitude
                    let longitude = position.coords.longitude
                    map.setView([latitude, longitude], 16)
                    if (lat && lng) {
                        setMark(lat, lng)
                    } else {
                        if (automark) setMark(latitude, longitude)
                    }
                    // console.log({zoom, latitude, longitude, position})
                },
                () => {
                    // Failed
                    console.log('No permitions')
                    latitude = 0
                    longitude = 0
                }
            )
        } else if (hasLocation) {
            setMark(lat, lng)
            map.setView([lat, lng], 20)
        }
    })

    function searchLocations(q) {
        return fetch(
            `https://nominatim.openstreetmap.org/search?q=${q}&format=json`,
            { headers: { 'Accept-Language': 'es-AR' } }
        ).then(async (r) => await r.json())
    }

    function reverseSearch(coordinates) {
        let [lat, lng] = coordinates.map((x) => x.toFixed(10))
        return fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`,
            { headers: { 'Accept-Language': 'es-AR' } }
        ).then(async (r) => {
            let ret = await r.json()
            search = ret?.display_name.split(', ').slice(0, 4).join(', ')
            return ret
        })
    }

    function execSearch() {
        loading = true
        searchLocations(search).then((x) => {
            if (x?.length > 0) {
                let [location] = x
                let { lat, lon } = location
                map.setView([lat, lon], zoom < 15 ? zoom : 15)
            }
            loading = false
            clearTimeout(cursor)
        })
    }

    function typingSearch() {
        clearTimeout(cursor)
        cursor = setTimeout(() => {
            execSearch()
        }, 5000)
        cursor
    }

    onDestroy(() => {
        clearTimeout(cursor)
    })

    $: [lat, lng] = coordinates // Update lat, lng

    $: if (lastLocation !== `${lat},${lng}`) {
        // Update Location Metadata
        // $:if (map && (lat || lng)){
        reverseSearch([lat, lng]).then((ret) => {
            locationMetadata = ret
            search = ret?.display_name.split(', ').slice(0, 4).join(', ')
        })
        setMark(lat, lng)
    }

    function lockMap() {
        if (map) {
            map.dragging.disable()
            map.touchZoom.disable()
            map.doubleClickZoom.disable()
            map.scrollWheelZoom.disable()
            map.boxZoom.disable()
            map.keyboard.disable()
            ele.style.cursor = 'default'
        }
    }

    function unlockMap() {
        if (map) {
            map.dragging.enable()
            map.touchZoom.enable()
            map.doubleClickZoom.enable()
            map.scrollWheelZoom.enable()
            map.boxZoom.enable()
            map.keyboard.enable()
            if (map.tap) map.tap.enable()
            ele.style.cursor = 'grab'
        }
    }

    $: if (disabled === true) {
        lockMap()
    } else {
        unlockMap()
    }
    // console.log({cf})
</script>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<!-- svelte-ignore a11y-positive-tabindex -->
<div class="container" style={searchBar ? '' : 'grid-template-rows: 1fr'}>
    <!-- <input type="text" disabled={loading} {placeholder} bind:value={search}
		on:keypress={e => {
			let {code} = e
			if (code=='Enter'){
				execSearch()
			} else {
				typingSearch()
			}
		}}
	/> -->
    {#if searchBar}
        <SearchField
            disabled={loading}
            {placeholder}
            bind:value={search}
            on:keypress={(e) => {
                let {
                    detail: {
                        event: { code },
                    },
                } = e
                if (code == 'Enter') {
                    execSearch()
                } else {
                    typingSearch()
                }
            }}
        />
    {/if}
    <!-- svelte-ignore a11y-positive-tabindex -->
    <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
    <div
        id="map"
        class="leaflet-container leaflet-touch leaflet-fade-anim leaflet-grab leaflet-touch-drag leaflet-touch-zoom"
        tabindex="1"
        bind:this={ele}
    ></div>
    <!-- style={`transform: scale(${cf+1}); transform-origin: top right`} -->
</div>

<style>
    .container {
        margin: 0;
        display: grid;
        min-width: 150px;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr;
        position: relative;
        min-width: 150px;
        width: 100%;
        height: 100%;
        padding: 0;
        align-items: center;
        flex-direction: column;
    }
    #map {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        user-select: none;
    }
    /* input[type="text"]{
		width: 100%;
		text-indent: 15px;
		padding: 5px;
		margin: 0;
		padding: 0;
		border-style: none;
	}
	input[type="text"]:focus {
		outline: none;
	} */
</style>
